import React, { useEffect, useRef, useState, useMemo } from "react";
import Select from "react-select";
import { API_URL, LOCATION_ID } from "..";
import CreatableSelect from "react-select/creatable";


const AddPurchaseOrderLayer = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [items, setItems] = useState([{ item_name: "", quantity: "1", rate: "", sellprice:"", amount: "" , sellPrice:""}]);
  const [expenses, setExpenses] = useState([{ expense_name: null, expense_amount: "" }]);
  const [message, setMessage] = useState({ status: false, reason: "", desc: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const [stockOptions, setStockOptions] = useState([]);
  const [poNumber, setPoNumber] = useState();

  // ✅ Fetch suppliers

  const today = new Date().toISOString().split("T")[0];
  useEffect(()=>{
     const locationId = localStorage.getItem('locationID')
    const fetchNextNumber = async () =>{
      const nextPO = await fetch(`${API_URL}/api/purchase-orders/po/next-po-number?locationId=${locationId}`)
  .then(r => r.json());

setPoNumber(nextPO.nextPO);
    }

    fetchNextNumber()
      
  },[])
  useEffect(() => {
     const locationId = localStorage.getItem('locationID')
    fetch(`${API_URL}/api/suppliers?locationId=${locationId}`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data?.suppliers.map((s) => ({ label: s.name, value: s.id }));
        setSuppliers(formatted);
      })
      .catch(() => setMessage({ status: true, reason: "error", desc: "Failed to load suppliers" }));
  }, []);

  useEffect(() => {
     const locationId = localStorage.getItem('locationID')
  fetch(`${API_URL}/api/invoice/stock/fetch?locationId=${locationId}`)
    .then(res => res.json())
    .then(data => {
      const formatted = data?.stock.map(s => ({
        label: s.title,
        value: s.title,     // item_name will be string
        rate: s.costPrice,
        sellPrice: s.sellPrice
      }));
      setStockOptions(formatted);
    });
}, []);

  // ✅ Expense options
  const expenseOptions = [
    "710101 - Office Rent",
    "710102 - Warehouse Rent",
    "710103 - Factory Rent",
    "710104 - Lease Payments",
    "710201 - Electricity Expense",
    "710202 - Gas Expense",
    "710203 - Water Expense",
    "710204 - Telephone & Internet Expense",
    "710301 - Printing & Stationery",
    "710302 - Postage & Courier Charges",
    "710303 - Office Supplies",
    "710401 - Entertainment Expense",
    "710402 - Staff Refreshments",
    "710403 - Meeting & Seminar Expense",
    "710501 - Vehicle Fuel",
    "710502 - Vehicle Maintenance",
    "710503 - Vehicle Registration",
    "710504 - Vehicle Running Expense",
    "710505 - Vehicle Insurance",
    "710506 - Vehicle Repair & Servicing",
    "710601 - Travelling Expense (Local)",
    "710602 - Travelling Expense (International)",
    "710603 - Conveyance & Taxi",
    "710701 - Repairs & Maintenance (Office Equipment)",
    "710702 - Repairs & Maintenance (Building)",
    "710703 - Generator Maintenance",
    "710801 - Cleaning & Sanitation",
    "710802 - Security Services",
    "710901 - Advertising & Promotion",
    "710902 - Printing of Brochures & Marketing Material",
    "710903 - Digital Marketing Expense",
    "711001 - Audit Fee",
    "711002 - Legal & Professional Charges",
    "711003 - Consultancy Charges",
    "711004 - Accounting Services Fee",
    "711101 - Bank Charges",
    "711102 - Interest Expense",
    "711103 - Service Charges",
    "711201 - Insurance Expense (General)",
    "711202 - Property Insurance",
    "711203 - Medical Insurance",
    "711204 - Life Insurance",
    "711301 - Internet & Website Hosting",
    "711302 - Software Subscription",
    "711303 - IT Support & Maintenance",
    "711401 - Subscriptions & Memberships",
    "711402 - License & Renewal Fee",
    "711403 - Training & Development",
    "711404 - Staff Welfare",
    "711501 - Uniforms & Protective Gear",
    "711502 - Staff Incentives",
    "711503 - Salary & Wages",
    "711504 - Overtime Expense",
    "711505 - Employee Benefits (Other)",
    "711601 - Depreciation Expense",
    "711602 - Amortization Expense",
    "711603 - Bad Debts Written Off",
    "711701 - Miscellaneous Expense",
    "720101 - Sales Promotion",
    "720102 - Freight Outward",
    "720103 - Carriage Outward",
    "720104 - Delivery Vehicle Expense",
    "720105 - Commission on Sales",
    "720106 - Sales Incentives",
    "720107 - Trade Discounts Allowed",
    "720201 - Advertisement & Marketing",
    "720202 - Sales Exhibition Expense",
    "720203 - Traveling & Representation",
    "720204 - After Sales Service Expense",
    "720301 - Packaging Material",
    "720302 - Wrapping Material",
    "720303 - Cartage & Loading Charges",
    "730101 - Bank Charges",
    "730102 - Interest on Overdraft",
    "730103 - Interest on Loans",
    "730104 - Late Payment Surcharges",
    "730105 - Exchange Loss",
    "730201 - Penalties & Fines",
    "730202 - Donations",
    "730203 - Zakat & Charity",
  ].map((e) => ({ value: e, label: e }));

  // ✅ Handle items
  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    if (field === "quantity" || field === "rate") {
      const qty = parseFloat(updated[index].quantity || 0);
      const rate = parseFloat(updated[index].rate || 0);
      updated[index].amount = (qty * rate).toFixed(2);
    }
    setItems(updated);
  };
  const addItemRow = () => setItems([...items, { item_name: "", quantity: "", rate: "", sellprice :"", amount: "" }]);
  const removeItemRow = (i) => setItems(items.filter((_, idx) => idx !== i));

  // ✅ Handle expenses
  const handleExpenseChange = (index, field, value) => {
    const updated = [...expenses];
    updated[index][field] = value;
    setExpenses(updated);
  };
  const addExpenseRow = () => setExpenses([...expenses, { expense_name: null, expense_amount: "" }]);
  const removeExpenseRow = (i) => setExpenses(expenses.filter((_, idx) => idx !== i));

  // ✅ Calculate total (auto)
  const totalItems = useMemo(() => items.reduce((sum, i) => sum + Number(i.amount || 0), 0), [items]);
  const totalExpenses = useMemo(() => expenses.reduce((sum, e) => sum + Number(e.expense_amount || 0), 0), [expenses]);
  const grandTotal = (totalItems + totalExpenses).toFixed(2);

  // ✅ Submit PO
  const submitPO = async (e) => {
    e.preventDefault();
    setMessage({ status: false, reason: "", desc: "" });

    const form = formRef.current;
    const formData = {
      supplier_id: selectedSupplier?.value,
      po_number: form.po_number.value,
      date: form.date.value,
      remarks: form.remarks.value,
      locationId : LOCATION_ID,
      items,
      expenses: expenses.map((e) => ({
        expense_name: e.expense_name?.value || "",
        expense_amount: e.expense_amount,
      })),
    };

    if (!formData.supplier_id)
      return setMessage({ status: true, reason: "error", desc: "Supplier is required" });
    if (!formData.po_number)
      return setMessage({ status: true, reason: "error", desc: "PO Number is required" });

    setIsSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/purchase-orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ status: true, reason: "success", desc: "Purchase Order created successfully" });
        window.location.href = "/list-po";
        form.reset();
        setSelectedSupplier(null);
        setItems([{ item_name: "", quantity: "", rate: "", sellprice :"", amount: "" }]);
        setExpenses([{ expense_name: null, expense_amount: "" }]);
      } else throw new Error(data.message || "Failed to create PO");
    } catch (err) {
      setMessage({ status: true, reason: "error", desc: err.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-8 col-xl-10 col-lg-10">
            <div className="card border">
              <div className="card-body">
                {message.status && (
                  <div className={`alert alert-${message.reason === "error" ? "danger" : "success"} mb-20`}>
                    {message.desc}
                    <button type="button" className="btn-close float-end" onClick={() => setMessage({ ...message, status: false })}></button>
                  </div>
                )}

                <form ref={formRef} onSubmit={submitPO}>
                  {/* Supplier */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">Supplier <span className="text-danger">*</span></label>
                    <Select options={suppliers} placeholder="Select Supplier" value={selectedSupplier} onChange={setSelectedSupplier} />
                  </div>

                  {/* PO Number */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">PO Number <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name="po_number" value={poNumber} placeholder="Enter PO Number" />
                  </div>

                  {/* Date */}
                <div className="mb-20">
  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
    Date <span className="text-danger">*</span>
  </label>
  <input
    type="date"
    className="form-control"
    name="date"
    defaultValue={today}   // 👈 default date
  />
</div>

                  {/* Items */}
                  <h6 className="fw-semibold text-primary mb-2">Order Items</h6>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Item</th><th>Qty</th><th>Rate</th><th>Sell Price</th><th>Amount</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, i) => (
                        <tr key={i}>
<td style={{ minWidth: "250px" }}>
  <CreatableSelect
    value={item.item_name ? { label: item.item_name, value: item.item_name } : null}
    options={stockOptions}
    placeholder="Select or type item..."
    onChange={(opt) => {
      const selected = opt ? opt.value : "";
      handleItemChange(i, "item_name", selected);

      // auto-fill rate & sell price if selected from stock
      const stock = stockOptions.find(s => s.value === selected);
      if (stock) {
        handleItemChange(i, "rate", stock.rate);
        handleItemChange(i, "sellPrice", stock.sellPrice);
      }
    }}
    onCreateOption={(inputValue) => {
      // user typed a new item
      handleItemChange(i, "item_name", inputValue);
    }}
  />
</td>
                          <td><input type="number" className="form-control" value={item.quantity} onChange={(e) => handleItemChange(i, "quantity", e.target.value)} /></td>
                          <td><input type="number" className="form-control" value={item.rate} onChange={(e) => handleItemChange(i, "rate", e.target.value)} /></td>
                          <td><input type="number" className="form-control" value={item.sellPrice} onChange={(e) => handleItemChange(i, "sellPrice", e.target.value)} /></td>
                          <td><input className="form-control" value={item.amount} readOnly /></td>
                          <td>{items.length > 1 && <button type="button" className="btn btn-sm btn-danger" onClick={() => removeItemRow(i)}>Remove</button>}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button type="button" className="btn btn-outline-primary mt-2" onClick={addItemRow}>+ Add Item</button>

                  {/* Expenses */}
                  <h6 className="fw-semibold text-primary mb-2 mt-4">Additional Expenses</h6>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Expense Name</th><th>Amount</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenses.map((exp, i) => (
                        <tr key={i}>
                          <td style={{ minWidth: "300px" }}>
                            <Select options={expenseOptions} value={exp.expense_name} onChange={(opt) => handleExpenseChange(i, "expense_name", opt)} placeholder="Select Expense" />
                          </td>
                          <td>
                            <input type="number" className="form-control" value={exp.expense_amount} onChange={(e) => handleExpenseChange(i, "expense_amount", e.target.value)} />
                          </td>
                          <td>{expenses.length > 1 && <button type="button" className="btn btn-sm btn-danger" onClick={() => removeExpenseRow(i)}>Remove</button>}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button type="button" className="btn btn-outline-primary mt-2" onClick={addExpenseRow}>+ Add Expense</button>

                  {/* ✅ Total Summary */}
                  <div className="mt-4 text-end">
                    <h6 className="fw-semibold text-primary mb-1">Total Items: Rs. {totalItems.toLocaleString()}</h6>
                    <h6 className="fw-semibold text-primary mb-1">Total Expenses: Rs. {totalExpenses.toLocaleString()}</h6>
                    <h5 className="fw-bold text-success mt-2">Grand Total: Rs. {grandTotal.toLocaleString()}</h5>
                  </div>

                  {/* Remarks */}
                  <div className="mt-4 mb-3">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">Remarks</label>
                    <textarea name="remarks" className="form-control" rows="2" placeholder="Optional remarks..." />
                  </div>

                  {/* Submit */}
                  <div className="text-center mt-3">
                    <button type="submit" className="btn btn-primary px-56 py-12" disabled={isSubmitting}>
                      {isSubmitting ? "Submitting..." : "Submit Order and View All"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPurchaseOrderLayer;
